export default __webpack_public_path__ + "static/media/best-specialty.f1ee9ba6.svg";